import React from 'react';
import { getCoverKey } from 'application/components/utils';
import styles from './index.module.scss';
import { TEXTS } from '../../texts';

interface Props {
  previewUrl?: string;
  title?: string | null;
}

const MAX_DEFAULT_COVERS_COUNT = 4;

const VideoStreamPreviewItemPoster: React.FC<Props> = ({ previewUrl, title }) => {
  if (!previewUrl) {
    return (
      <div
        className={styles.Poster}
        // TEMP replace to default image
        data-hash={getCoverKey(title || TEXTS.VIDEO_STREAM_INFO_TITLE, MAX_DEFAULT_COVERS_COUNT)}
      />
    );
  }

  return (
    <img
      src={previewUrl}
      alt=""
      loading="lazy"
      className={styles.Poster}
    />
  );
};

export default VideoStreamPreviewItemPoster;
